export default __webpack_public_path__ + "b78cfeab273f022c47bb510cd960502d.png";